(function () {
  'use strict';

  var O = window.MMOffers || {};
  var sheet, offersEl, normalBtn, pendingNormal = null;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function t(en, ar) {
    if (O.t) {
      var ctx = document.querySelector('[data-mm-product-offers]');
      return O.t(en, ar, ctx);
    }
    var arL = (document.documentElement.lang || '').indexOf('ar') === 0;
    return arL ? ar : en;
  }

  function typeLabel(type) {
    if (O.typeLabel) {
      return O.typeLabel(type, document.querySelector('[data-mm-product-offers]'));
    }
    return type;
  }

  function offerName(offer) {
    if (O.offerTitle) return O.offerTitle(offer, null, document.querySelector('[data-mm-product-offers]'));
    return offer.title || offer.name || typeLabel(offer.type);
  }

  async function fetchOffers(handle) {
    if (window.__mmPrefetch && window.__mmPrefetch.fetchOffers) {
      return window.__mmPrefetch.fetchOffers(handle);
    }
    var url = O.offersApiUrl ? O.offersApiUrl({ productHandle: handle }) : '/apps/mm-app/api/offers?productHandle=' + encodeURIComponent(handle);
    var r = await fetch(url);
    return r.ok ? r.json() : { offers: [], settings: {} };
  }

  function blockSelector(type) {
    if (type === 'BOGO') return '[data-mm-bogo-block]';
    if (type === 'BUNDLE') return '[data-mm-bundle-block]';
    if (type === 'VOLUME') return '[data-mm-volume-block]';
    return '[data-mm-product-offers]';
  }

  function scrollToOffer(type) {
    var el = document.querySelector(blockSelector(type));
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    el.classList.add('mmo-card--pulse');
    setTimeout(function () { el.classList.remove('mmo-card--pulse'); }, 1600);
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mmo-atc-sheet-open');
    pendingNormal = null;
  }

  function openSheet(offers, onNormal) {
    sheet = document.getElementById('mmoAtcSheet');
    offersEl = document.getElementById('mmoAtcSheetOffers');
    normalBtn = document.getElementById('mmoAtcSheetNormal');
    if (!sheet || !offersEl || !normalBtn) {
      onNormal();
      return;
    }

    pendingNormal = onNormal;
    offersEl.innerHTML = offers.map(function (offer) {
      return '<button type="button" class="mmo-atc-sheet__offer" data-offer-type="' + esc(offer.type) + '">' +
        '<span class="mmo-atc-sheet__offer-badge">' + esc(typeLabel(offer.type)) + '</span>' +
        '<span class="mmo-atc-sheet__offer-name">' + esc(offerName(offer)) + '</span>' +
        '<span class="mmo-atc-sheet__offer-go" aria-hidden="true">→</span>' +
      '</button>';
    }).join('');

    offersEl.querySelectorAll('[data-offer-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeSheet();
        scrollToOffer(btn.getAttribute('data-offer-type'));
      });
    });

    normalBtn.onclick = function () {
      var fn = pendingNormal;
      closeSheet();
      if (fn) fn();
    };

    sheet.querySelectorAll('[data-mmo-atc-close]').forEach(function (el) {
      el.onclick = closeSheet;
    });

    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mmo-atc-sheet-open');
  }

  window.MMOffersAtcChooser = {
    intercept: async function (opts) {
      var handle = opts && opts.handle;
      var onNormal = opts && opts.onNormal;
      if (!handle || !onNormal) return;

      try {
        var data = await fetchOffers(handle);
        var offers = (data.offers || []).filter(function (o) {
          return o && (o.type === 'BOGO' || o.type === 'BUNDLE' || o.type === 'VOLUME');
        });
        if (!offers.length) {
          onNormal();
          return;
        }
        openSheet(offers, onNormal);
      } catch (e) {
        onNormal();
      }
    }
  };
})();
